<template>
<div>
    <el-container style="height: 700px; border: 1px solid #eee; margin:0 100px 0 100px">
        <el-aside width="200px" style="background-color: rgb(238, 241, 246); height: 200px">
            <h1 class="title">联系我们</h1>
            <hr class="fenge" size="5px" noshade=true/>
            <el-menu default-active="2" class="el-menu-vertical-demo">
                <el-menu-item index="2">
                    <i class="el-icon-phone"></i>
                    <span slot="title">联系信息</span>
                </el-menu-item>
            </el-menu>
        </el-aside>
    <el-container> 
    <el-main>
        <h2 style="margin-bottom: 0px; margin-top: 0px">绍兴上虞三源通风设备有限公司</h2>
        <p style="font-size:50%">SHAOXING SHANGYU SANYUAN VENTILATOR CO.,LTD.</p>
        <p>公司地址：浙江省绍兴市上虞区上浦镇104国道东侧</p>
        <p style="margin-top: 30px">联系人：张先生</p>
        <p>联系电话：13819534097</p>
        <p style="margin-top: 30px">联系人：吴先生</p>
        <p>联系电话：13587384022</p>
        <div>
        <baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler">
            <!--缩放-->
            <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
            <!--定位-->
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
            <!--点-->
            <bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">
                <!--提示信息-->
                <bm-info-window :show="map.show">
                    <p style="margin-block-start: 0.5em; margin-block-end: 0px;"><b>绍兴上虞三源通风设备有限公司</b></p>
                    <p style="font-size:12px;margin-block-start: 0.5em;">绍兴市上虞区上浦镇104国道东侧</p>
                </bm-info-window>
            </bm-marker>
        </baidu-map>
    </div>
    </el-main>
  </el-container>
</el-container>
</div> 
</template>

<script>
    export default {
        name: "demo",
        data: () => ({
            map:{
                center: {lng: 120.841563, lat: 29.90584},
                zoom: 12,
                show: true,
                dragging: true
            },
        }),
        methods: {
            handler ({BMap, map}) {
                console.log(BMap, map)
                // 鼠标缩放
                map.enableScrollWheelZoom(true);
                // 点击事件获取经纬度
                map.addEventListener('click', function (e) {
                    console.log(e.point.lng, e.point.lat)
                })
            }
        }
    }
</script>
 
<style scoped>
    .map {
        width: 100%;
        height: 350px;
    }

.fenge {
    width: 95px;
    margin-top: 0;
    margin-left: 15px;
    background-color: rgb(24, 140, 179);
    border: rgb(24, 140, 179);
    box-shadow: 0 0 0 0;
}

.title {
    font-size: 200%;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 15px;
}
</style>